/**
 * meta.js
 * Written by: Alex Kasemir
 */

import questionActions from '../../actions';

/**
 * Description of the meta reducer
 */
const meta = (state = {}, action) => {
  switch (action.type) {
    case questionActions.GET_QUESTION_START:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          loading: true,
          loaded: false,
        },
      };
    case questionActions.GET_QUESTION_SUCCESS:
    case questionActions.GET_QUESTION_FAILURE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          loading: false,
          loaded: true,
        },
      };
    case questionActions.SUBMIT_QUESTION_START:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          submitting: true,
          submitted: false,
        },
      };
    case questionActions.SUBMIT_QUESTION_SUCCESS:
    case questionActions.SUBMIT_QUESTION_FAILURE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          submitting: false,
          submitted: true,
        },
      };
    case questionActions.CLEAR_QUESTIONS_META:
      return {};
    default:
      return state;
  }
};

export default meta;
